var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBriefcaseBusiness(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "briefcase-business"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 7.99947H8.00667M10.6669 3.99947V2.66613C10.6669 2.31251 10.5264 1.97337 10.2763 1.72332C10.0263 1.47328 9.68709 1.3328 9.33344 1.3328H6.66656C6.31291 1.3328 5.97374 1.47328 5.72368 1.72332C5.47361 1.97337 5.33312 2.31251 5.33312 2.66613V3.99947M14.6672 8.66613C12.6889 9.97212 10.3706 10.6683 8 10.6683C5.62944 10.6683 3.3111 9.97212 1.3328 8.66613M2.66624 3.99947H13.3338C14.0702 3.99947 14.6672 4.59642 14.6672 5.3328V11.9995C14.6672 12.7358 14.0702 13.3328 13.3338 13.3328H2.66624C1.9298 13.3328 1.3328 12.7358 1.3328 11.9995V5.3328C1.3328 4.59642 1.9298 3.99947 2.66624 3.99947Z",
    stroke: "#6B6F7A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcaseBusiness);
export default __webpack_public_path__ + "static/media/briefcase-business.fe1930109ac79b39509626811b64b79b.svg";
export { ForwardRef as ReactComponent };